var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresetData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.50489,
    y: 13.6743,
    width: 102.498,
    height: 85.415
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.69px)",
      clipPath: "url(#bgblur_0_9890_4842_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 11.3887,
    x: 18.8936,
    y: 25.063,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083,
    fill: "url(#paint0_linear_9890_4842)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 42.6252,
    width: 79.375,
    height: 61.875,
    rx: 15.625,
    fill: "url(#paint1_linear_9890_4842)",
    stroke: "white",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9890_4842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4606 81.1468C60.1059 81.1468 57.7533 81.1534 55.3986 81.1446C54.0843 81.1379 53.3288 80.5504 53.3001 79.5475C53.2714 78.5027 54.0511 77.8665 55.4185 77.8643C60.1633 77.8576 64.9081 77.851 69.653 77.8731C70.3046 77.8753 70.6934 77.7119 71.0556 77.1088C73.0967 73.7114 77.4903 73.7225 79.5314 77.1176C79.8583 77.661 80.2007 77.8908 80.8347 77.8753C82.4163 77.8356 83.9979 77.851 85.5795 77.8687C86.7723 77.8819 87.5212 78.538 87.5167 79.5121C87.5123 80.4819 86.7591 81.1291 85.5618 81.1424C84.0178 81.16 82.4715 81.1755 80.9274 81.1357C80.2692 81.1181 79.8782 81.308 79.5203 81.9044C77.4815 85.2974 73.0945 85.2863 71.0424 81.8846C70.711 81.3345 70.3709 81.1269 69.7413 81.1357C67.3159 81.1667 64.8882 81.1468 62.4606 81.1468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6524 68.8628C76.4457 68.8628 74.2367 68.8849 72.03 68.8495C71.332 68.8385 70.9233 69.0307 70.5434 69.6735C68.5796 72.9891 64.0535 72.9847 62.1206 69.6602C61.7385 69.002 61.3276 68.8363 60.6406 68.8495C58.8381 68.8849 57.0356 68.876 55.2309 68.854C54.0094 68.8385 53.287 68.2001 53.3025 67.2127C53.318 66.2253 54.0403 65.6223 55.2729 65.6134C57.1483 65.598 59.0259 65.5913 60.9035 65.6178C61.4447 65.6245 61.7429 65.4544 62.0256 64.9662C64.0667 61.4363 68.5531 61.4054 70.6185 64.9198C70.9653 65.5074 71.3563 65.62 71.9505 65.6178C76.2557 65.6024 80.561 65.609 84.8662 65.6112C85.1975 65.6112 85.5289 65.598 85.8602 65.6223C86.8388 65.6907 87.4993 66.3247 87.5192 67.1972C87.5412 68.1184 86.8719 68.8297 85.8293 68.8451C83.4392 68.8805 81.0469 68.8562 78.6546 68.8562C78.6524 68.8562 78.6524 68.8584 78.6524 68.8628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.734 93.3998C76.4522 93.3998 74.1703 93.4197 71.8907 93.3888C71.2633 93.38 70.9187 93.581 70.5896 94.142C68.5662 97.5792 64.0467 97.5482 62.0498 94.0824C61.745 93.5522 61.4202 93.38 60.8393 93.3888C58.9639 93.4175 57.0863 93.4109 55.2087 93.3932C54.0092 93.3799 53.278 92.7195 53.3023 91.7277C53.3266 90.7756 54.0136 90.1703 55.18 90.1549C57.02 90.1306 58.8601 90.124 60.7001 90.1571C61.354 90.1703 61.7361 89.998 62.0918 89.3862C64.0555 85.9998 68.5839 85.9998 70.5741 89.3817C70.932 89.9914 71.323 90.1593 71.9768 90.1571C76.1716 90.135 80.3664 90.146 84.5612 90.146C84.8926 90.146 85.2239 90.1394 85.5552 90.1483C86.7945 90.1836 87.5124 90.7734 87.519 91.7564C87.5256 92.7416 86.7901 93.3844 85.5818 93.391C83.2977 93.4109 81.0159 93.3998 78.734 93.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9890_4842_clip_path",
    transform: "translate(-7.50489 -13.6743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.8936,
    y: 25.063,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9890_4842",
    x1: 41.8899,
    y1: 38.765,
    x2: 105.044,
    y2: 66.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9890_4842",
    x1: 69.1875,
    y1: 42.0002,
    x2: 69.1875,
    y2: 105.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9890_4842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2189,
    height: 34.4,
    fill: "white",
    transform: "translate(53.3003 62.3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresetData);
export default __webpack_public_path__ + "static/media/preset_data.2582662d13d67a655d4bea4f7219e770.svg";
export { ForwardRef as ReactComponent };